<template>
     <v-container fluid>
        <v-dialog
      v-model="loadingPdf"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="tables-basic">
      <br>
      <h1 v-if="verNuevo==0"  class="page-title mt-16 mb-6">Resguardos</h1>
      <v-row>
        <v-col cols="12">
          <v-card class="employee-list mb-1">
            <v-card-title class="pa-6 pb-3">
                <v-btn @click="mostrarNuevo()"  v-if="verNuevo==0"  rounded color="primary" small dark>Nueva Asignación</v-btn>
              <v-spacer></v-spacer>
              
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                clearable
                single-line
                hide-details
                 v-if="verNuevo==0"
              ></v-text-field>
            </v-card-title>
            <v-data-table
            
              dense
              :headers="headers"
              :items="resguardos"
              :search="search"
             
               v-if="verNuevo==0"
              >
              
            <template v-slot:[`item.action`]="{item}">
                <v-icon @click="editItem(item)" small class="mr-2" >mdi-border-color</v-icon>
                 <v-icon @click="generarPdf(item)" small class="mr-2" >mdi-download</v-icon>
            </template>
            <template v-slot:[`item.fechaEntrega`]="{item}">
             {{  item.fecha | moment("dddd Do MMMM YYYY, h:mm a")}}
            </template>
            <template v-slot:[`item.infoActivo`]="{item}">
                {{item.activo.nombreActivo +' '+ item.activo.modelo}}
            </template>
             <template v-slot:[`item.estatu`]="{item}">
            <v-chip small v-if="item.activo.estatu=='N/D'"  color="gray" text-color="black">
                N/D
            </v-chip>
            <v-chip small v-if="item.activo.estatu=='Operativo'"  color="green" text-color="white">
                Operativo
            </v-chip>
            <v-chip small v-if="item.activo.estatu=='Fuera de Servicio'"  color="orange" text-color="white">
                Fuera de Servicio
            </v-chip>
             <v-chip small v-if="item.activo.estatu=='No Localizado'"  color="red" text-color="white">
                No Localizado
            </v-chip>
            </template>
               <template v-slot:[`item.fecha`]="{ item }">
          {{  item.fecha | moment("dddd Do MMMM YYYY, h:mm a")}}
              </template>

           
        
        
            </v-data-table>
            
                 <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
                                        <span class="headline">{{ formTitle }}</span>

        <v-layout row wrap>       

            <v-flex xs11 sm11 lg11 x11>
                <v-stepper v-model="e6" vertical>
                    <v-stepper-step :complete="e6 > 1" step="1">
                     Tipo de Movimiento
                    <small>Datos requeridos para continuar</small>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                        <v-row>
                            <v-col col="12">
                                <v-radio-group v-model="tipoMovimiento" row>
                                    <v-radio class="pa-0 mb-4" label="Asignación a Personal" value="Asignación a Personal"></v-radio>
                                    <v-radio class="pa-0 mb-4" label="Traslado Interno" value="Traslado Interno"></v-radio>
                                    <v-radio class="pa-0 mb-4" label="Comodato" value="Comodato"></v-radio>
                                    <v-radio class="pa-0 mb-4" label="Traslado Externo" value="Traslado Externo"></v-radio>
                                    <v-radio class="pa-0 mb-4" label="Devolución" value="Devolución"></v-radio>
                                    <v-radio class="pa-0 mb-4" label="Retiro completo del Activo" value="Retiro completo del activo"></v-radio>
                                </v-radio-group>
                            </v-col>
                       
                           
                        </v-row>
                        <v-btn color="primary" small  @click="continuarStepper()"> Continuar</v-btn>
                        <v-btn small @click="cancelarStepper()">Cancel</v-btn>
                    </v-stepper-content>
                    <v-stepper-step :complete="e6 > 2" step="2">
                      Entrega - Asignación
                    </v-stepper-step>
                    <v-stepper-content step="2">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete  :items="personales" v-model="usuarioEntrega" label="Entrega"></v-autocomplete>
                            </v-col>
                          
                             <v-col cols="12" sm="6">
                              <v-autocomplete  :items="personales" v-model="usuarioRecibe" label="Recibe"></v-autocomplete>
                            </v-col>     
                        </v-row>
                    <v-btn color="primary" @click="continuarStepper()">
                        Continue
                    </v-btn>
                    <v-btn text @click="cancelarStepper()">
                        Cancel
                    </v-btn>
                    </v-stepper-content>
                    <v-stepper-step :complete="e6 > 3" step="3">
                        Datos del Activo
                    </v-stepper-step>
                    <v-stepper-content step="3">
                        <v-row>
                            <v-col cols="12" sm="4">
                                  <v-text-field v-model="activo2" @keyup.enter="listarActivpoPorNss()"  class="text-xs-center" append-icon="mdi-search" label="Numero de Serie"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" v-if="$store.state.usuario.rol!=='capturista'">
                                  <v-text-field v-model="numeroEconomicoBusqueda" @keyup.enter="listarActivpoPorNumeroEconomico()"  class="text-xs-center" append-icon="mdi-search" label="Numero Economico"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                  <v-text-field v-model="facturaBusqueda" @keyup.enter="listarActivpoPorFactura()"  class="text-xs-center" append-icon="mdi-search" label="Factura"></v-text-field>
                            </v-col>
                           
                        </v-row>
                        <v-row>
                            <v-col col="6">
                                <v-textarea solo v-model="observaciones" label="Observaciones"></v-textarea>
                            </v-col>
                        
                            
                            <v-col v-if="mostrarDetalleDeActivo">
                                <v-card
                                    elevation="24"
                                    max-width="444"
                                    class="mx-auto"
                                >
                                    <v-system-bar lights-out></v-system-bar>
                                    <v-carousel
                                    :continuous="false"
                                    :cycle="cycle"
                                    :show-arrows="false"
                                    hide-delimiter-background
                                    delimiter-icon="mdi-minus"
                                    height="300"
                                    >
                                   <v-carousel-item
                                            v-for="(item, i) in activoPorQuery.fotos"
                                            :key="i"
                                        >
                                            <v-img :src="item" contain max-height="300"></v-img>
                                        </v-carousel-item>
                                    </v-carousel>
                                    <v-list densetwo-line>
                                    <v-list-item>
                                        <v-list-item-avatar>
                                        <v-img src="https://i.ibb.co/RhFJyQn/trianguloflecha-Mesa-de-trabajo-1.png"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                        <v-list-item-title>{{activoPorQuery.personal.nombreCompleto}}</v-list-item-title>
                                        <v-list-item-subtitle>{{activoPorQuery.personal.empresa.nombreComercial}}</v-list-item-subtitle>

                                        </v-list-item-content>        
                                    </v-list-item>
                                    </v-list>
                                    <v-divider></v-divider>
                                    <v-list dense>
                                        <v-list-item>
                                         <v-list-item-content>
                                            <v-list-item-subtitle>Tipo de Unidad: <strong>{{activoPorQuery.tipoUnidad}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Activo: <strong>{{activoPorQuery.nombreActivo}}</strong></v-list-item-subtitle>                    
                                            <v-list-item-subtitle>Marca: <strong>{{activoPorQuery.marca}}</strong> Modelo: <strong>{{activoPorQuery.modelo}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Numero de Serie: <strong>{{activoPorQuery.numeroSerie}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Estatus: <strong>{{activoPorQuery.estatu}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Factura: <strong>{{activoPorQuery.factura}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Costo: <strong> ${{activoPorQuery.costo.toLocaleString('en-US')}}</strong></v-list-item-subtitle>

                                         </v-list-item-content>

                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                       
                        <v-btn color="primary" @click="continuarStepper()">Continue</v-btn>
                    <v-btn @click="cancelarStepper()" text>Cancel</v-btn>
                    </v-stepper-content>
                    <v-stepper-step :complete="e6 > 4" step="4">
                        Clausula de Compromiso
                    </v-stepper-step>
                    <v-stepper-content step="4">
                    <v-row>
                        <v-card-text>
                            <p>
Declaro que la herramienta, equipo, y utiles de trabajo relacionados en el presente documento están bajo mi responsabilidad, por lo cual daré
uso exclusivo y adecuado al desempeño de mis funciones y a la destinación institucional prevista para cada uno de ellos, en base a lo que ha
sido dispuesto según mi descripción de puesto y el procedimiento relativo al sistema de gestión de calidad de la corporación. En consecuencia,
serán asumidos por mi los daños o la pérdida de los mismos debido a mi negligencia o incumplimiento de las instrucciones respecto de su uso
y conservación.                            </p>
<p>Me comprometo a informar oportunamente sobre cualquier desplazamiento, traslado temporal o definitivo de dichos activos mediante la
tramitación del formato respectivo y sobre cualquier situación que ponga en inminente riesgo los bienes relacionados.</p>
<p>Dado la omisión de estas disposiciones es considerada como falta grave, asumo las consecuencias económicas que conlleven el daño o la
pérdida de los bienes mencionados si ocurren por mi negligencia o incumplimiento, y en tal evento autorizo a Corporativo Industrial y
Comercial S.A. de C.V. a efectuar un acta administrativa. Para la constancia de tal compromiso y el calculo de los daños que corresponde
cuando la responsabilidad es inherente al asignado, se establece que su valor de factura y, que los calculos se harán bajo este valor, menos la
depreciación del equipo en base a la fecha de la posible correncia de los actos contrarios a las buenas practicaas y buen uso.</p>
                      
                        </v-card-text>
                    </v-row>
                    <v-btn color="primary" @click="continuarStepper()">
                        Acepto
                    </v-btn>
                    <v-btn @click="cancelarStepper()" text>
                        Cancel
                    </v-btn>
                    </v-stepper-content>
                     <v-stepper-step step="5">
                        Firma
                    </v-stepper-step>
                    <v-stepper-content step="5">
                    <v-row>
                        <v-col  cols="12" sm="4">
                            Entrega
                            <div id="app" >
                                    <vueSignature style=" border: 1px solid;" ref="signatureEntrega" :sigOption="optionSignature" :w="'240px'" :h="'200px'" :disabled="disabled" :defaultUrl="dataUrl"></vueSignature> 
                                   
                                    <v-btn @click="clearSignatureEntrega">Limpiar</v-btn>
                                   
                                </div>                            
                            </v-col>
                            <v-col  cols="12" sm="4">
                            Recibe
                            <div id="app" >
                                    <vueSignature style=" border: 1px solid;" ref="signatureRecibe" :sigOption="optionSignature" :w="'240px'" :h="'200px'" :disabled="disabled" :defaultUrl="dataUrl"></vueSignature> 
                                   
                                    <v-btn @click="clearSignatureRecibe">Limpiar</v-btn>
                                </div>                            
                            </v-col>
                           
                    </v-row>
                    <v-row>
                         <v-col col="6">
 <v-btn color="primary" @click="guardar()">
                        Guardar
                    </v-btn>
                    <v-btn @click="cancelarStepper()" text>
                        Cancel
                    </v-btn>
                            </v-col>
                    </v-row>
                   
                  
                    </v-stepper-content>
                </v-stepper>
            </v-flex>    
           
        </v-layout>
    </v-container>
          </v-card>
        </v-col>
      </v-row>
    </div>
  
     </v-container>
</template>

<script>
import axios from 'axios'
import vueSignature from "vue-signature"
import moment from 'moment'
import jsPDF from 'jspdf'
import apiCatalogo from '../../api/Catalogo'
export default {
   name: "app",
	components:{
		vueSignature
	},
    data(){
        return{
            headers: [
                { text: "Actions", value: "action", sortable: false },
                { text: "Activo", value: "infoActivo", sortable: true },   
                { text: "Folio", value:"folio_resguardo", sortable:true},
                { text: "Responsable Actual", value: "activo.personal.nombreCompleto", sortable: true }, 
                { text: "Personal que Entrega", value: "usuarioEntrega.nombreCompleto", sortable: true },
                { text: "Personal que Recibe", value: "usuarioRecibe.nombreCompleto", sortable: true },
                { text: "Empresa del Responsable", value: "usuarioRecibe.empresa.nombreComercial", sortable: true },
                { text: "Fecha de Entrega", value : "fecha"},
                { text: "Estatus", value: "estatu", sortable: true },

            ],
            personales:[],
            search:'',
            activos:[],
            tipoMovimiento:'',
            usuarioEntrega:'',
            observaciones:'',
            activo2:'',
            usuarioRecibe:'',
            loadingPdf:false,
           resguardos:[],
            nombreActivo:'',
          numeroEconomicoBusqueda:'',
          facturaBusqueda:'',
            personal:'',
       activo:'',
            detalle:'',
            anio:'',
            numeroDeSerie:'',
             menu: false,
      modal: false,
      menu2: false,
            logoImg:'data:image/png;base64,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',
            mostrarDetalleDeActivo:false,
            ubicacionPorQuery:'',
            estatu:'',
            capacidad:'',
            dialogNuevaArrendadora:false,
            razonSocial:'',
            verNuevo:0,
            activoPorQuery:[],
             editedIndex: -1,
            dataUrl:"",
            logo:'',
            
             e6: 1,
            nombreComercial:'',
            tiposDeUnidad:['Autos y Pick Ups','Motocicletas','Tractocamion','Plataforma','Grúa Terrestre','Montacargas','Cargador Frontal'],
            estatus:['N/D','Operativo','Fuera de Servicio','No Localizado'],
            submited:'',
            alert:'',
            options: {
            locale: "en-US",
            prefix: "$",
            suffix: "",
            length: 11,
            clausula:'Declaro que la herramienta, equipo, y utiles de trabajo relacionados en el presente documento están bajo mi responsabilidad, por lo cual daré uso exclusivo y adecuado al desempeño de mis funciones y a la destinación institucional prevista para cada uno de ellos, en base a lo que ha sido dispuesto según mi descripción de puesto y el procedimiento relativo al sistema de gestión de calidad de la corporación. En consecuencia, serán asumidos por mi los daños o la pérdida de los mismos debido a mi negligencia o incumplimiento de las instrucciones respecto de su uso y conservación. Me comprometo a informar oportunamente sobre cualquier desplazamiento, traslado temporal o definitivo de dichos activos mediante la tramitación del formato respectivo y sobre cualquier situación que ponga en inminente riesgo los bienes relacionados. Dado la omisión de estas disposiciones es considerada como falta grave, asumo las consecuencias económicas que conlleven el daño o la pérdida de los bienes mencionados si ocurren por mi negligencia o incumplimiento, y en tal evento autorizo a Corporativo Industrial y Comercial S.A. de C.V. a efectuar un acta administrativa. Para la constancia de tal compromiso y el calculo de los daños que corresponde cuando la responsabilidad es inherente al asignado, se establece que su valor de factura y, que los calculos se harán bajo este valor, menos la depreciación del equipo en base a la fecha de la posible correncia de los actos contrarios a las buenas practicaas y buen uso.',
            observaciones:'',
            precision: 2,
            },
             company_logo:{
                w: 110,
                h: 35
            },
            optionSignature:{
				penColor:"rgb(0, 0, 0)",
				backgroundColor:"rgb(240,240,240)"
			},
			disabled:false,
            colors: [
          'green',
          'secondary',
          'yellow darken-4',
          'red lighten-2',
          'orange darken-1',
        ],
        cycle: false,
        slides: [
          'First',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
        ],
     
   
    
        }
    },
    computed: {
        formTitle() {
        return this.editedIndex === -1 ? "Nueva Asignación" : "Editar Asignación";
        }
    },
    created(){
        this.selectPersonal()
        this.selectActivo()
        this.listar()
    },
    methods:{
        listar(){
            let me = this;
            axios.get('/resguardo/list/').then(function (response){
                me.resguardos = response.data
          }).catch(function(error){
                console.log(error)
            })
        },
         obtenerUbicacion(_id){
            axios.get('/ubicacion/query?_id='+_id).then(function (response){
              return response.data.ubicacion
            }).catch(function(error){
                console.log(error)
            })
        },
        listarActivpoPorNss(){
            let me = this
            let empresaUsuario = this.$store.state.usuario.personal.empresa;
            let usuario = this.$store.state.usuario.rol;
            axios.get('/activos/queryNss?numeroSerie='+this.activo2).then(function (response){
                if(usuario=='capturista'){
                    if(empresaUsuario==response.data.personal.empresa._id){
                        me.activoPorQuery = response.data
                        me.activo2 = response.data._id
                        me.mostrarDetalleDeActivo = true
                    }else{
                        me.addErrorNotification()
                    }
                }else{
                    me.activoPorQuery = response.data
                me.activo2 = response.data._id
                me.mostrarDetalleDeActivo = true
                }
             
            }).catch(function(error){
                console.log(error)
            })
        },
        listarActivpoPorNumeroEconomico(){
            let me = this
            axios.get('/activos/queryNumeroEconomico?numeroEconomico='+this.numeroEconomicoBusqueda).then(function (response){
                me.activoPorQuery = response.data
                me.mostrarDetalleDeActivo = true
            }).catch(function(error){
                console.log(error)
            })
        },
        listarActivpoPorFactura(){
            let me = this
            let empresaUsuario = this.$store.state.usuario.personal.empresa;
            let usuario = this.$store.state.usuario.rol;
            axios.get('/activos/queryFactura?factura='+this.facturaBusqueda).then(function (response){
                if(usuario=='capturista'){
                    if(empresaUsuario==response.data.personal.empresa._id){
                        me.activoPorQuery = response.data
                        me.mostrarDetalleDeActivo = true
                    }else{
                        me.addErrorNotification
                    }
                }else{
                    me.activoPorQuery = response.data
                me.mostrarDetalleDeActivo = true
                }
               
            }).catch(function(){
               me.addErrorNotification()
            })
        },
        limpiar(){
            this.arrendadora='',
            this.razonSocial=''
        },

        guardar(){
            let me = this
            var signatureRecibe = this.$refs.signatureRecibe.save()
			var signatureEntrega = this.$refs.signatureEntrega.save()
            
            if(this.editedIndex>-1){
               
                axios.put('/resguardo/update',
                {'_id':this._id,
                 'tipoMovimiento':this.tipoMovimiento,
                'usuarioEntrega':this.usuarioEntrega,
                'usuarioRecibe':this.usuarioRecibe,
                'activo':this.activo2,
                'observaciones':this.observaciones,
                'signatureEntrega': signatureRecibe,
                'signatureRecibe': signatureEntrega,
                })
                .then(function(){
                    
                    me.listar()
                    me.addSuccessNotification('Activo actualizado')
                    me.ocultarNuevo()
                })
                .catch(function(error){
                    console.log(error)
                })
            }else{
            

            axios.post('/resguardo/add',{
                'tipoMovimiento':this.tipoMovimiento,
                'usuarioEntrega':this.usuarioEntrega,
                'usuarioRecibe':this.usuarioRecibe,
                'activo':this.activo2,
                'observaciones':this.observaciones,
                'signatureEntrega': signatureRecibe,
                'signatureRecibe': signatureEntrega,
            })
            .then(function(res){
                me.editarPersonal(res.data.activo,res.data.usuarioRecibe)
                me.listar()
                me.ocultarNuevo()
                me.addSuccessNotification('Activo agregado')
                me.limpiar()
            })
            .catch(function(error){
                console.log(error)
            })
            }
        },
        selectPersonal(){
            let me = this;
            let personalArray=[];
            let empresaUsuario = this.$store.state.usuario.personal.empresa;
            let usuario = this.$store.state.usuario.rol;
            axios.get('/personal/list').then((response)=>{
              if(usuario=='capturista'){
                response.data.forEach((e)=>{
                    if(e.departamento.empresa==empresaUsuario){
                        personalArray.push(e)
                    }
                })
              }else{
                personalArray=response.data;
              }
              
              personalArray.map(function(x){
                me.personales.push({text:x.nombreCompleto, value:x._id})
              });
            }).catch(function(error){
              console.log(error);
            })
          },
        selectActivo(){
            let me = this;
            let activoArray=[];
            axios.get('/activos/list').then((response)=>{
              activoArray=response.data;
              activoArray.map(function(x){
                me.activos.push({text:x.nombreActivo +' '+ x.marca+' '+x.modelo+' '+x.numeroSerie, value:x._id})
              });
            }).catch(function(error){
              console.log(error);
            })
          },
          editarPersonal(id,personal){
             
              axios.put('/activos/updatePersonal',{
                  '_id':id,
                  'personal':personal
              }).catch((err)=>{
                  console.log(err)
              })
          },
        editItem(item) {
           
            this._id = item._id;
            this.tipoMovimiento = item.tipoMovimiento;
            this.usuarioEntrega = item.usuarioEntrega._id;
            this.usuarioRecibe = item.usuarioRecibe._id;
            this.activo = item.activo._id;
            this.activo2 = item.activo._id
            this.obtenerIdActivo()
            this.observaciones = item.observaciones;
          
            this.editedIndex = 1;

           this.mostrarNuevo()
        },

        toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },

        generarPdf(item){

            this.loadingPdf = true
            var doc = new jsPDF("p", "pt","a4");
            var startX=40;
            var startY=40;
       //Encabezado
            apiCatalogo.obtenerDepartamentos().then(()=>{
                if(this.$store.state.usuario.personal.empresa=='6207f8cb7422680c1e59051c'){
                doc.addImage('https://i.ibb.co/JpWrrFW/amlslogo.jpg',"jpeg",startX,startY+=5,this.company_logo.w-50,this.company_logo.h);
            }else{
                doc.addImage(this.logoImg,"jpeg",startX,startY+=5,this.company_logo.w,this.company_logo.h);
            }

            doc.setFontSize(12)
            doc.setFont(undefined, 'bold')
           
            if(item.activo.estatusActivo == true && item.activo.personal._id == '620bd9fb5ab18c95f201933a'){
                doc.text('Asiganación',42,100);
            }else{
                doc.text('Reasignación',42,100)
            }
            doc.setFont(undefined, 'normal')
            doc.setFontSize(8)
            doc.text('Fecha',275,100);
            doc.rect(305, 88, 90, 15,)
            let fecha = moment(item.fecha).subtract(10, 'days').calendar()
            doc.text(fecha,313,100);
            doc.text('Folio',408,100);
            doc.rect(430, 88, 105, 15,)
            doc.text(item.folio_resguardo.toString(),440,100);


            //Tipo de Movimiento
            doc.setFillColor(196,196,196);
            doc.rect(40, 119, 495, 10, 'F')
            doc.setFont(undefined, 'bold')
            doc.text('Tipo de Movimiento',42,127)
            doc.rect(40, 129, 495, 50)
            doc.setFont(undefined, 'normal')
            doc.text('Asignación a Personal',140,145)
            doc.text('Traslado Externo',140,168)
            doc.text('Traslado Interno',295,145)
            doc.text('Devolución',295,168)
            doc.text('Comodato',415,145)
            doc.text('Retiro Completo del Activo',415,168)
            if(item.tipoMovimiento == 'Asignación a Personal'){
                doc.rect(120, 137, 10, 10,'F')
                doc.rect(275, 137, 10, 10)
                doc.rect(395, 137, 10, 10)
                doc.rect(120, 160, 10, 10)
                doc.rect(275, 160, 10, 10)
                doc.rect(395, 160, 10, 10)
            }else if(item.tipoMovimiento == 'Traslado Interno'){
                doc.rect(120, 137, 10, 10)
                doc.rect(275, 137, 10, 10,'F')
                doc.rect(395, 137, 10, 10)
                doc.rect(120, 160, 10, 10)
                doc.rect(275, 160, 10, 10)
                doc.rect(395, 160, 10, 10)
            }else if(item.tipoMovimiento == 'Comodato'){
                doc.rect(120, 137, 10, 10)
                doc.rect(275, 137, 10, 10)
                doc.rect(395, 137, 10, 10,'F')
                doc.rect(120, 160, 10, 10)
                doc.rect(275, 160, 10, 10)
                doc.rect(395, 160, 10, 10)
            }else if(item.tipoMovimiento == 'Traslado Externo'){
                doc.rect(120, 137, 10, 10)
                doc.rect(275, 137, 10, 10)
                doc.rect(395, 137, 10, 10)
                doc.rect(120, 160, 10, 10,'F')
                doc.rect(275, 160, 10, 10)
                doc.rect(395, 160, 10, 10)
            }else if(item.tipoMovimiento == 'Devolución'){
                doc.rect(120, 137, 10, 10)
                doc.rect(275, 137, 10, 10)
                doc.rect(395, 137, 10, 10)
                doc.rect(120, 160, 10, 10)
                doc.rect(275, 160, 10, 10,'F')
                doc.rect(395, 160, 10, 10)
            }else if(item.tipoMovimiento == 'Retiro completo del activo'){
                doc.rect(120, 137, 10, 10)
                doc.rect(275, 137, 10, 10)
                doc.rect(395, 137, 10, 10)
                doc.rect(120, 160, 10, 10)
                doc.rect(275, 160, 10, 10,)
                doc.rect(395, 160, 10, 10,'F')
            }
            //Origen Entrega

            doc.setFillColor(196,196,196);
            doc.rect(40, 190, 250, 10, 'F')
            doc.setFont(undefined, 'bold')
            doc.text('Origen (Entrega)',42,197)
            doc.rect(40, 200, 250, 60)

            doc.setFillColor(196,196,196);
            doc.rect(308, 190, 227, 10, 'F')
            doc.setFont(undefined, 'bold')
            doc.text('Destino (Recibe)',311,197)
            doc.rect(308, 200, 227, 60)

            doc.setFont(undefined, 'normal')
            doc.text('Entregado por:',65,215)
            doc.text('Empresa:',65,225)
            doc.text('Departamento:',65,235)
            doc.text('Correo:',65,245)
            doc.text('Telefono:',65,255)
            doc.setFont(undefined, 'bold')
            doc.text(item.usuarioEntrega.nombreCompleto,130,215)
            doc.text(item.usuarioEntrega.empresa.nombreComercial,130,225)
            doc.text(item.usuarioEntrega.departamento.departamento,130,235)
            doc.text(item.usuarioEntrega.correo,130,245)
            doc.text(item.usuarioEntrega.telefono.toString(),130,255)

            doc.setFont(undefined, 'normal')
            doc.text('Recibido por:',325,215)
            doc.text('Empresa:',325,225)
            doc.text('Departamento:',325,235)
            doc.text('Correo:',325,245)
            doc.text('Telefono:',325,255)
            doc.setFont(undefined, 'bold')
            doc.text(item.usuarioRecibe.nombreCompleto,385,215)
            doc.text(item.usuarioRecibe.empresa.nombreComercial,385,225)
            doc.text(item.usuarioRecibe.departamento.departamento,385,235)
            doc.text(item.usuarioRecibe.correo,385,245)
            doc.text(item.usuarioRecibe.telefono.toString(),385,255)

            //Información de activos
            doc.setFillColor(196,196,196);
            doc.rect(40, 270, 495, 10, 'F')
            doc.setFont(undefined, 'bold')
            doc.text('Información de los Activos',42,278)
            doc.setFillColor(196,196,196);
            doc.rect(40, 290, 250, 10, 'F')
            doc.text('Foto del Activo',42,298)
            doc.rect(40, 300, 250, 190)
            
            if(item.activo.fotos.length>=4){
           
            // const objFots = [item.activo.fotos[0],item.activo.fotos[0],item.activo.fotos[1]]
            // console.log(objFots)
            
               doc.addImage(item.activo.fotos[1],'jpeg',43,303,120,90)
              doc.addImage(item.activo.fotos[2],'jpeg',167,303,120,90)
               doc.addImage(item.activo.fotos[3],'jpeg',43,395,120,90)
               doc.addImage(item.activo.fotos[4],'jpeg',167,395,120,90)
            }else if(item.activo.fotos.length==1){
                 doc.addImage(item.activo.fotos[1],43,305,240,180)
            }
            doc.setFillColor(196,196,196);
            doc.rect(310, 290, 226, 10, 'F')
            doc.text('Descripcion del Activo',312,298)

            doc.setFont(undefined, 'normal')
            doc.text('Tipo de Unidad:',333,313)
            doc.text('Activo:',365,328)
            doc.text('Marca:',365,342)
            doc.text('Modelo:',361,358)
            doc.text('Año:',373,373)
            doc.text('Numero de Serie:',327,388)
            doc.text('Factura:',361,403)
            doc.text('# Economico:',342,418)
            doc.text('Clave Microsip:',336,433)
            doc.text('Costo:',367,448)
            doc.text('Fecha de Adquisición:',312,463)
            doc.text('Estatus:',362,478)
            doc.rect(310, 300, 226, 190)
            doc.text(item.activo.tipoUnidad,410,313)
            doc.text(item.activo.nombreActivo,410,328)
            doc.text(item.activo.marca,410,342)
            doc.text(item.activo.modelo.slice(0,24),410,358)
            doc.text(item.activo.anio.toString(),410,373)
            doc.text(item.activo.numeroSerie,410,388)
            doc.text(item.activo.factura,410,403)
            doc.text(item.activo.numeroEconomico,410,418)
            doc.text(item.activo.claveMicrosip,410,433)
            doc.text(item.activo.costo.toString(),410,448)
            if(item.activo.fechaDeAdquisicion){
                let fechaAdquisicion = moment(item.activo.fechaDeAdquisicion).subtract(10, 'days').calendar();
            doc.text(fechaAdquisicion,410,463)
            }
           
            doc.text(item.activo.estatu,410,478)

            doc.setFillColor(196,196,196);
            doc.rect(40, 500, 495, 10, 'F')
            doc.setFont(undefined, 'bold')
            doc.text('Observaciones',42,508)
            doc.rect(40, 510, 495, 50)
            doc.setFont(undefined, 'normal')
            if(item.observaciones){
                doc.text(item.observaciones,42,520)
            }
           

            doc.setFillColor(196,196,196);
            doc.rect(40, 570, 495, 10, 'F')
            doc.setFont(undefined, 'bold')
            doc.text('Cláusula de compromiso',42,578)
            doc.rect(40, 570, 495, 120)
            doc.setFont(undefined, 'normal')
            doc.text('Declaro que la herramienta, equipo, y utiles de trabajo relacionados en el presente documento están bajo mi responsabilidad, por lo cual',42,592,{align:'justify'}),
            doc.text('por lo cual daré uso exclusivo y adecuado al desempeño de mis funciones y a la destinación institucional prevista para cada uno de ellos',42,600,{align:'justify'}),
            doc.text('en base a lo que hasido dispuesto según mi descripción de puesto y el procedimiento relativo al sistema de gestión de calidad de la.',42,608,{align:'justify'}),
            doc.text('corporación. En consecuencia,serán asumidos por mi los daños o la pérdida de los mismos debido a mi negligencia o incumplimiento de',42,616,{align:'justify'}),
            doc.text('las instrucciones respecto de su uso y conservación.',42,624, {align:'justify'})
            doc.text('Me comprometo a informar oportunamente sobre cualquier desplazamiento, traslado temporal o definitivo de dichos activos mediante la',42,632,{align:'justify'})
            doc.text('tramitación del formato respectivo y sobre cualquier situación que ponga en inminente riesgo los bienes relacionados.',42,640,{align:'justify'})
            doc.text('Dado la omisión de estas disposiciones es considerada como falta grave, asumo las consecuencias económicas que conlleven el daño',42,648,{align:'justify'})
           

            if(this.$store.state.usuario.personal.empresa=='6207f8cb7422680c1e59051c'){
                doc.text('o la pérdida de los bienes mencionados si ocurren por mi negligencia o incumplimiento, y en tal evento autorizo a Arrow Marine Logistics',42,656,{align:'justify'})
                doc.text('Services S. de R.L. de C.V. a efectuar un acta administrativa. Para la constancia de tal compromiso y el calculo de los daños ',42,664,{align:'justify'})
            }else{
                doc.text('o la pérdida de los bienes mencionados si ocurren por mi negligencia o incumplimiento, y en tal evento autorizo a Corporativo Industrial y',42,656,{align:'justify'})
                doc.text('Comercial S.A. de C.V. a efectuar un acta administrativa. Para la constancia de tal compromiso y el calculo de los daños',42,664,{align:'justify'})
            }
            
            doc.text('que corresponde cuando la responsabilidad es inherente al asignado, se establece que su valor de factura y, que los calculos se harán ,', 42,  672, {align:'justify'})
            doc.text('bajo este valor menos la depreciación del equipo en base a la fecha de la posible correncia de los actos contrarios a las buenas practicas',42, 680,{align:'justify'})
            doc.text('y buen uso.',42, 688,{align:'justify'})



          
            doc.addImage(Buffer.from(item.signatureEntrega.data, 'base64').toString('ascii'),120,700,120,80)
            doc.text('Entrega',165,790)
            doc.addImage(Buffer.from(item.signatureRecibe.data, 'base64').toString('ascii'),300,700,120,80)
            doc.text('Recibe',345,790)
            this.loadingPdf = false
              doc.save("resguardo.pdf")
         
            })
          
           
                    
        },

getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  var dataURL = canvas.toDataURL("image/png");
  return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
},
         mostrarNuevo(){
           // this.listarAgencia(this.$store.state.usuario.agencia)
            this.limpiar()
            this.verNuevo =1;

          },
            ocultarNuevo(){
            this.verNuevo =0
            this.limpiar();
          },

          obtenerIdActivo(){
               let me = this;
            axios.get('/activos/query?_id='+this.activo).then(function (response){
                me.activoPorQuery = response.data
                me.mostrarDetalleDeActivo = true
            }).catch(function(error){
                console.log(error)
            })
          },

        addSuccessNotification(mensaje) {
                this.$toast.success(mensaje, {
                position: 'top-right',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true
            });
        },
         addErrorNotification() {
                this.$toast.error("Error, verifique los campos ingresados", {
                position: 'bottom-right',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true
            });   
        },
        cerrarModalArrendadora(){
            this.dialogNuevaArrendadora =false;
            this.limpiar()
            this.editedIndex = -1
        },
        continuarStepper(){
            if(this.e6==1){
                    this.e6=2
            }else if(this.e6==2){
                    this.e6=3
            }else if(this.e6==3){
                    this.e6=4
            }else if(this.e6==4){   
                    this.e6=5
            }
        },
        cancelarStepper(){
            if(this.e6==1){
                this.ocultarNuevo()
            }else if(this.e6==2){
                this.e6 = this.e6-1
            }else if(this.e6==3){
                this.e6 = this.e6-1
            }else if(this.e6==4){
                this.e6 = this.e6-1
            }
        },

        loadImageAsDataURL(url) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL());
            }
            img.onerror = reject;
            img.src = url;
        });
        },

      
		clearSignatureRecibe(){
			var _this = this;
			_this.$refs.signatureRecibe.clear();
		},
        clearSignatureEntrega(){
			var _this = this;
			_this.$refs.signatureEntrega.clear();
		},
		undo(){
			var _this = this;
			_this.$refs.signature.undo();
		},
		addWaterMark(){
			var _this = this;
			_this.$refs.signature.addWaterMark({
				text:"mark text",          // watermark text, > default ''
				font:"20px Arial",         // mark font, > default '20px sans-serif'
				style:'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill		
				fillStyle:"red",           // fillcolor, > default '#333' 
				strokeStyle:"blue",	   // strokecolor, > default '#333'	
				x:100,                     // fill positionX, > default 20
				y:200,                     // fill positionY, > default 20				
				sx:100,                    // stroke positionX, > default 40
				sy:200                     // stroke positionY, > default 40
			});
		},
		fromDataURL(){
			var _this = this;
			_this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
		},
		handleDisabled(){
			var _this = this;
			_this.disabled  = !_this.disabled
		}

    }
}
</script>
